import gql from 'graphql-tag';
import collegeEventFilterFragment from '../../CollegeEventsEditEvent/graphql/collegeEventFilterFragment';

export default gql`
  mutation createCollegeEventFilter($input: createCollegeEventFilterInput!) {
    createCollegeEventFilter(input: $input) {
      collegeEventFilter {
      ...CollegeEventFilter 
    }
  }
}
  ${collegeEventFilterFragment}
`;
